<template>
  <div class="evaluation-rule" :class="{ active: hover, top: !indexPrefix }" @mouseover.stop="handleMouseover"
    @mouseout="handleMouseout">
    <div class="parent">
      <div class="name" :style="{ paddingLeft: indent * 10 + 'px' }">
        <div>
          <span style="color: #409eff">{{ cIndex }}</span> {{ rule.name }}
        </div>
        <div style="font-size: 12px; color: gray" :style="{ paddingLeft: (indent + 1) * 12 + 'px' }">
          {{ rule.comment }}
        </div>
      </div>
      <div class="score">
        <template>
          <template>
            <el-tag v-if="rule.scoreable && rule.multiple" size="mini" style="margin-right: 5px">可多次</el-tag>
            <el-tag v-if="rule.scoreable && !rule.multiple" size="mini" style="margin-right: 5px">仅一次</el-tag>
            <el-tag class="score-tag" :type="rule.scoreable ? 'danger' : 'success'" size="mini" effect="dark">{{
              rule.score }} 分</el-tag>
          </template>
        </template>
      </div>
      <div class="actions" v-role="['owner', 'admin']">
        <i class="el-icon-edit" @click="handleUpdate"></i>
        <i class="el-icon-plus" @click="handleCreate"></i>
        <el-popconfirm icon-color="red" confirm-button-text="删除" confirm-button-type="danger"
          icon="el-icon-warning-outline" title="已在进行测评的表，不建议删除。" @onConfirm="handleDelete" @confirm="handleDelete">
          <i class="el-icon-close" slot="reference"></i>
        </el-popconfirm>
        <i class="el-icon-top" @click="handleReorder({ offset: -1, id: rule.id })"></i>
        <i class="el-icon-bottom" @click="handleReorder({ offset: 1, id: rule.id })"></i>
      </div>
    </div>

    <div class="children">
      <evaluation-rule v-for="(item, i) in rule.children" :rule="item" :key="item.id" :indexPrefix="cIndex" :index="i"
        @updated="$emit('updated')"></evaluation-rule>
    </div>
    <CreateUpdateDialog :visible.sync="dialogVisible" :data="form" @submited="$emit('updated')"></CreateUpdateDialog>
  </div>
</template>
<script>
import {
  reorderEvaluationRule,
  deleteEvaluationRule,
} from "@/api/evaluation-rule";

import CreateUpdateDialog from "./create-update-dialog.vue";
import defaultForm from "./default-form.json";

export default {
  name: "EvaluationRule",
  data() {
    return {
      hover: false,
      form: defaultForm,
      dialogVisible: false,
    };
  },
  components: {
    CreateUpdateDialog,
  },
  computed: {
    // 标签名
    cIndex() {
      return (
        this.indexPrefix +
        (this.indexPrefix ? "." : "") +
        (parseInt(this.index) + 1)
      );
    },

    // 缩进
    indent() {
      return this.cIndex.split(".").length - 1;
    },
  },
  props: {
    rule: {
      type: Object,
      default: () => {
        return {};
      },
    },
    indexPrefix: {
      type: String,
      default: "",
    },
    index: {
      type: Number,
      default: 1,
    },
  },
  mounted() {},
  methods: {
    handleMouseover() {
      this.hover = true;
    },
    handleMouseout() {
      this.hover = false;
    },
    handleReorder(params) {
      reorderEvaluationRule(params.id, { offset: params.offset }).then(() => {
        this.$emit("updated");
      });
    },
    handleDelete() {
      deleteEvaluationRule(this.rule.id).then(() => {
        this.$emit("updated");
      });
    },
    handleCreate() {
      this.form = JSON.parse(JSON.stringify(defaultForm));
      this.form.parent_id = this.rule.id;
      this.form.evaluation_form_id = this.rule.evaluation_form_id;
      this.dialogVisible = true;
    },
    handleUpdate() {
      this.form = this.rule;
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="less" scoped>
.evaluation-rule {
  // border: 1px solid gray;
  margin: 5px 0;

  &.active {
    background-color: #f2f6fd;
  }

  &.top {
    border-left: 1px solid #1d81fc3f;
    border-right: 1px solid #1d81fc3f;
    margin-bottom: 10px;
    background-color: #fcfcfc;
  }

  .actions {
    display: flex;
    align-items: center;

    i {
      padding: 0 5px;
      color: #409eff;
      cursor: pointer;
    }

    .el-icon-close {
      color: red;
    }
  }
}

.parent {
  padding: 5px 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  // background-color: #f9f9f9;
  border-bottom: 1px solid #f2f2f2;

  &:hover {
    background-color: #dfeafd;
  }
}

// .index {
//   color: gray;
//   border-radius: 3px;
//   background-color: #f6f6f6;
//   margin-right: 10px;
//   padding: 2px 5px;
//   text-align: center;
//   width: 30px;
//   text-align: left;
// }

.name {
  flex: 1;
  text-align: left;
}

.score {
  width: 150px;
  text-align: right;
  margin-right: 30px;

  .minus {
    color: red;
  }

  .score-tag {
    width: 50px;
    text-align: center;
  }
}

.children {
  // margin-left: 10px;
}

.imageList {
  display: flex;
  margin: 10px 0;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 40px 20px;
}
</style>
